import React from "react";
import Typography from '@material-ui/core/Typography';
import Container from "@material-ui/core/Container";
import {makeStyles} from "@material-ui/core/styles";
import {injectIntl} from "react-intl";
import Grid from "@material-ui/core/Grid";
import HorizontalScroll from "../../common/HorizontalScroll";
import IdeaPreview from "./IdeaPreview";
import _ from 'lodash';

const useStyles = makeStyles(theme => ({
    container: {
        backgroundColor: 'white',
        position: 'relative',
        overflow: 'hidden',
        [theme.breakpoints.up('md')]: {
            paddingBottom: '20px'
        },
    },
    contentWrapper: {
        position: 'relative',
        zIndex: 1
    },
    text1: {
        paddingTop: '65px',
        color: theme.palette.indigo.dark,
        fontSize: '60px',
        lineHeight: '1.1',
        fontFamily: 'Open Sans',
        textAlign: 'center',
        [theme.breakpoints.down('xl')]: {
            fontSize: '55px',
        },
        [theme.breakpoints.down('lg')]: {
            fontSize: '45px',
        },
        [theme.breakpoints.down('xs')]: {
            fontSize: '32px',
        }
    }
}));

export const itemsToRender = (ideas, intl) => {
    if (ideas.length < 10) {
    const now = new Date();
    const defaultIdeas = _.range(10 - ideas.length).map(i => ({
        name: intl.formatMessage({id: 'your_future_idea'}),
        description: `<p>${intl.formatMessage({id: 'your_future_idea_desc'})}</p>`,
        creatorName: 'Crowdea',
        createdAt: now,
        likeCount: i * 5,
        commentCount: Math.pow(i * 2, 2),
        viewCount: i * 10,
        defaultIdea: true
    }));
    return ideas.concat(defaultIdeas);
    } else return ideas;
};

const MostLikedIdeasPreview = props => {

    const classes = useStyles();
    const scrollContainerRef = React.useRef(null);
    const {ideas, intl} = props;

    return <div className={classes.container}>
        <Container maxWidth="xl" className={classes.contentWrapper}>
            <Grid container
                  direction="row"
                  justify="center"
                  alignItems="center"
                  spacing={4}
            >
                <Grid item xs={12}>
                    <Typography variant={'h1'} className={classes.text1}>
                        {intl.formatMessage({id: 'most_liked_ideas_preview'})}
                    </Typography>
                </Grid>
                <Grid item xs={12} style={{position: 'relative'}}>
                    <HorizontalScroll scrollContainerRef={scrollContainerRef}>
                        {itemsToRender(ideas, intl).map(idea => <IdeaPreview idea={idea}/>)}
                    </HorizontalScroll>
                </Grid>
            </Grid>
        </Container>
    </div>
};

export default injectIntl(MostLikedIdeasPreview);